var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
import _ from 'lodash';
import PersistentCollection from '../PersistentCollection';
import FilterRuleContainsString from '../filters/FilterRuleContainsString';
import ServiceEntryModel from '../../models/ServiceEntryModel';
import FilterObjectRule from '../filters/FilterObjectRule';
import SortModel from '../../models/SortModel';
import { toCSV, toXLSX } from '../../utils/exportUtils';
import ServiceEntryStatus from '../../data/ServiceEntryStatus';
import { compareDates, compareNumbers, compareStrings } from '../../utils/compareUtils';
import SchemaTriggerIntervalValueType from '../../data/SchemaTriggerIntervalValueType';
import FilterRuleArrayContains from '../filters/FilterRuleArrayContains';
import ViewOptions from '../../views/pages/Assets/data/ViewOptions';
import ClusterProperties from '../../views/pages/Assets/data/ClusterProperties';
import ServiceEntryPriority from '../../data/ServiceEntryPriority';
import * as atlas from "azure-maps-control";
var Position = atlas.data.Position;
var BoundingBox = atlas.data.BoundingBox;
/**
 *
 */
var ServiceEntryCollection = /** @class */ (function (_super) {
    __extends(ServiceEntryCollection, _super);
    /**
     * isPersistent boolean
     * storageName boolean
     */
    function ServiceEntryCollection(isPersistent, storageName) {
        if (isPersistent === void 0) { isPersistent = true; }
        if (storageName === void 0) { storageName = 'ServiceEntryCollection'; }
        var _this = _super.call(this, ServiceEntryModel, isPersistent, storageName) || this;
        _this.viewOption = ViewOptions.SERVICE;
        _this.clusterType = ClusterProperties.SERVICE;
        _this.sort = new SortModel({ fieldName: 'creationDateTimeUtc', direction: -1 });
        _this.searchStringFilter = new FilterRuleContainsString('filterString');
        _this.statusFilter = new FilterObjectRule(['calculatedStatus']);
        _this.labelsFilter = new FilterRuleArrayContains(['labelFilterArray'], false);
        _this.viewOption = ViewOptions.SERVICE;
        _this.clusterType = ClusterProperties.SERVICE;
        _this.filter.addRule(_this.searchStringFilter);
        _this.filter.addRule(_this.statusFilter);
        _this.filter.addRule(_this.labelsFilter);
        // naming for hash
        _this.statusFilter.name = 'status';
        _this.labelsFilter.name = 'labels';
        return _this;
    }
    Object.defineProperty(ServiceEntryCollection.prototype, "uniqueLabels", {
        /**
         *
         * @return {Array}
         */
        get: function () {
            var labels = [];
            this.list.forEach(function (model) {
                labels = labels.concat(model.labels);
            });
            return _.uniqWith(labels, function (labelA, labelB) { return labelA.id === labelB.id; });
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     * @param type
     * @param intl
     */
    ServiceEntryCollection.prototype.export = function (type, intl) {
        // Headers
        var rows = [[
                intl.formatMessage({ id: 'page.service.entries.table.column.status' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.assetid' }),
                intl.formatMessage({ id: 'page.assets.table.column.serialnumber' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.location' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.labels' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.name' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.description' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.priority' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.operatinghours' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.assignedto' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.operator' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.created' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.scheduled' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.due' }),
            ]];
        // Content
        rows = rows.concat(this.filteredAndSorted.map(function (serviceEntryModel) {
            return [
                intl.formatMessage({ id: 'service.entry.status.' + ServiceEntryStatus.getKeyByValue(serviceEntryModel.calculatedStatus) }),
                serviceEntryModel.assetEquipmentId,
                serviceEntryModel.assetId,
                serviceEntryModel.assetModel ? serviceEntryModel.assetModel.place : '',
                serviceEntryModel.name,
                serviceEntryModel.description,
                intl.formatMessage({ id: 'service.entry.priority.' + ServiceEntryPriority.getKeyByValue(serviceEntryModel.priority) }),
                serviceEntryModel.originatingTriggerValue ?
                    (SchemaTriggerIntervalValueType.isPeriodial(serviceEntryModel.triggerIntervalValueType) ? serviceEntryModel.originatingTriggerValueAsDate : serviceEntryModel.originatingTriggerValue) :
                    '',
                serviceEntryModel.cumulativeOperatingHoursDurationInHours,
                serviceEntryModel.assignedTo,
                serviceEntryModel.operatorName,
                serviceEntryModel.creationDateTimeUtc,
                serviceEntryModel.scheduledDateTimeUtc,
                serviceEntryModel.dueDateTimeUtc,
            ];
        }));
        var fileName = intl.formatDate(new Date(), {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        }) + ' ' + intl.formatTime(new Date()) + '_service-entries';
        switch (type) {
            case 'xlsx':
                toXLSX(rows, fileName);
                break;
            case 'csv':
                toCSV(rows, fileName);
        }
    };
    /**
     *
     * @param type
     * @param intl
     */
    ServiceEntryCollection.prototype.exportClosed = function (type, intl) {
        // Headers
        var rows = [[
                intl.formatMessage({ id: 'page.service.entries.table.column.assetid' }),
                intl.formatMessage({ id: 'page.assets.table.column.serialnumber' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.name' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.description' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.operator' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.assignedto' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.created' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.scheduled' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.due' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.closed' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.resolution' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.valueoncreate' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.valueonclose' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.operatinghours' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.status' }),
                intl.formatMessage({ id: 'page.service.entries.table.column.tags' })
            ]];
        // Content
        rows = rows.concat(this.filteredAndSorted.map(function (serviceEntryModel) {
            return [
                serviceEntryModel.assetEquipmentId,
                serviceEntryModel.assetId,
                serviceEntryModel.name,
                serviceEntryModel.description,
                serviceEntryModel.operatorName,
                serviceEntryModel.assignedTo,
                serviceEntryModel.creationDateTimeUtc,
                serviceEntryModel.scheduledDateTimeUtc,
                serviceEntryModel.dueDateTimeUtc,
                serviceEntryModel.closeDateTimeUtc,
                serviceEntryModel.resolution,
                serviceEntryModel.assetValueOnCreation,
                serviceEntryModel.assetValueOnClose,
                serviceEntryModel.cumulativeOperatingHoursDurationInHours,
                intl.formatMessage({ id: 'service.entry.status.' + ServiceEntryStatus.getKeyByValue(serviceEntryModel.status) }),
                serviceEntryModel.tags.map(function (tagObject) {
                    return tagObject.tagName;
                }).join(', ')
            ];
        }));
        var fileName = intl.formatDate(new Date(), {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        }) + ' ' + intl.formatTime(new Date()) + '_closed-service-entries';
        switch (type) {
            case 'xlsx':
                toXLSX(rows, fileName);
                break;
            case 'csv':
                toCSV(rows, fileName);
        }
    };
    /**
     *
     * @param items
     * @return {*}
     * @private
     */
    ServiceEntryCollection.prototype.applySort = function (items) {
        var sort = this.sort;
        if (!sort)
            return items;
        var result = items.concat([]);
        var now = new Date();
        result.sort(function (a, b) {
            switch (sort.fieldName) {
                case 'equipmentId':
                    return compareStrings(a.assetEquipmentId, b.assetEquipmentId);
                case 'calculatedStatus':
                    return compareNumbers(a.calculatedStatus, b.calculatedStatus);
                case 'priority':
                    return compareNumbers(a.priority, b.priority);
                case 'assetValueOnCreation':
                    return compareNumbers(a.assetValueOnCreation, b.assetValueOnCreation);
                case 'assetValueOnClose':
                    return compareNumbers(a.assetValueOnClose, b.assetValueOnClose);
                case 'cumulativeOperatingHoursDurationInHours':
                    return compareNumbers(a.cumulativeOperatingHoursDurationInHours, b.cumulativeOperatingHoursDurationInHours);
                case 'closeDateTimeUtc':
                    return compareDates(a.closeDateTimeUtc, b.closeDateTimeUtc);
                case 'creationDateTimeUtc':
                    return compareDates(a.creationDateTimeUtc, b.creationDateTimeUtc);
                case 'dueDateTimeUtc':
                    return compareDates(a.dueDateTimeUtc, b.dueDateTimeUtc);
                case 'scheduledDateTimeUtc':
                    return compareDates(a.scheduledDateTimeUtc, b.scheduledDateTimeUtc);
                case 'originatingTriggerValue':
                    return compareNumbers(a.originatingTriggerValue, b.originatingTriggerValue);
                case 'originatingTriggerValue.hours':
                    return compareNumbers(!SchemaTriggerIntervalValueType.isPeriodial(a.triggerIntervalValueType) ? now.getTime() - a.originatingTriggerValue : Number.MAX_VALUE, !SchemaTriggerIntervalValueType.isPeriodial(b.triggerIntervalValueType) ? now.getTime() - b.originatingTriggerValue : Number.MAX_VALUE);
                case 'originatingTriggerValue.interval':
                    return compareNumbers(SchemaTriggerIntervalValueType.isPeriodial(a.triggerIntervalValueType) ? a.cumulativeOperatingHoursDurationInHours - a.originatingTriggerValue : null, SchemaTriggerIntervalValueType.isPeriodial(b.triggerIntervalValueType) ? b.cumulativeOperatingHoursDurationInHours - b.originatingTriggerValue : null);
                case 'originatingTriggerReminderBeforeValue':
                    return compareDates(a.scheduledDateTimeUtc, b.scheduledDateTimeUtc);
                case 'labels':
                    if (a.labels.length === b.labels.length) {
                        return compareStrings(a.labelSortString, b.labelSortString);
                    }
                    else {
                        return compareNumbers(a.labels.length, b.labels.length);
                    }
                default:
                    return compareStrings(a[sort.fieldName], b[sort.fieldName]);
            }
        });
        if (sort.direction < 0) {
            result.reverse();
        }
        return result;
    };
    Object.defineProperty(ServiceEntryCollection.prototype, "assetModels", {
        /**
         *
         * @return {*[]}
         */
        get: function () {
            return this.list.map(function (serviceEntryModel) {
                return serviceEntryModel.assetModel;
            }).filter(function (assetModel) { return !!assetModel; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceEntryCollection.prototype, "filteredAssetModels", {
        /**
         *
         * @return {*[]}
         */
        get: function () {
            return this.filtered.map(function (serviceEntryModel) {
                return serviceEntryModel.assetModel;
            }).filter(function (assetModel) { return !!assetModel; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceEntryCollection.prototype, "boundingBox", {
        /**
         *
         * @return {atlas.data.BoundingBox}
         */
        get: function () {
            var positions = this.assetModels.map(function (assetModel) {
                if (assetModel.geometry.coordinates[0] === 0 && assetModel.geometry.coordinates[1] === 0) {
                    return null;
                }
                return new Position(assetModel.geometry.coordinates[0], assetModel.geometry.coordinates[1]);
            }).filter(function (val) { return val != null; });
            return BoundingBox.fromPositions(positions);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceEntryCollection.prototype, "filteredBoundingBox", {
        /**
         *
         * @return {atlas.data.BoundingBox}
         */
        get: function () {
            var positions = this.filteredAssetModels.map(function (assetModel) {
                if (assetModel.geometry.coordinates[0] === 0 && assetModel.geometry.coordinates[1] === 0) {
                    return null;
                }
                return new Position(assetModel.geometry.coordinates[0], assetModel.geometry.coordinates[1]);
            }).filter(function (val) { return val != null; });
            return BoundingBox.fromPositions(positions);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        observable
    ], ServiceEntryCollection.prototype, "viewOption", void 0);
    __decorate([
        observable
    ], ServiceEntryCollection.prototype, "tableShown", void 0);
    __decorate([
        observable
    ], ServiceEntryCollection.prototype, "clusterType", void 0);
    return ServiceEntryCollection;
}(PersistentCollection));
export default ServiceEntryCollection;
